module.exports = __webpack_public_path__ + "static/media/drone-alt.527f41ac.svg";